import React from "react";
import ScrollableAnchor from "react-scrollable-anchor";

const HealthySection = () => (
    <ScrollableAnchor id="healthy">
      <section className="content-section bg-secondary text-white text-center animatedParent animateOnce"
               data-sequence='500'>
        <div className="container">
          <div className="content-section-heading text-center">
            <h3 className="text-secondary mb-0">Info</h3>
            <h2 className="mb-5">BioFeedback</h2>
          </div>
          <div className="animated fadeInDownShort" data-id="1">
            <p className="textJustify">
              Das OBERON®-System ist ein naturheilkundliches Diagnostik-System, das die „multidimensionale nicht-lineare
              Systemanalyse“ (MNLS) verwendet sowie für die Alternativmedizin konzipiert ist.
              Die MNLS-Methode (Multidimensionale Nicht Lineare Systeme) ist eine nichtinvasive Methode. Nicht-invasiv
              bedeutet, dass die Messung induktiv, d.h. berührungsfrei über einen Kopfhörer, stattfindet, basieren auf
              weltweit einzigartigen Biophotonen- Technologie. Die MNLS-Analyse und das OBERON®-System ist für uns ein
              wunderbares Bindeglied zwischen der jahrtausendealten morgenländischen Heilkunst und der modernen
              Naturheilkunde.
              <br></br>
              <br></br>
              Multidimensionale Nicht-lineare Systeme - Was ist das?
              <br></br>
              <br></br>
              Die Idee der multidimensionalen Nicht-linearen Systeme stellt für uns mitunter die Basis für ein
              ganzheitliches Denken dar.
              Es geht darum, den Menschen mit seinem Geist, seiner Seele und seinem Organismus als komplexes Wesen zu
              sehen, was alles andere tut als nur linear von A bis B zu arbeiten. Sondern stattdessen alle möglichen
              Verknüpfungen wahrnimmt und so eine Kommunikation zwischen jedem Bestandteil unseres Seins zulässt. Ob wir
              diese Kommunikation „Wandlungsphase“, „Informationsfeld“ oder „Zellkommunikation“ nennen ist eine Frage
              der Perspektive. Es ist nebensächlich aus welcher Fachdisziplin Sie kommen, „Die Neue Art“ stellt die
              Verknüpfung aller Ansätze dar und vermittelt den Umgang mit diesem komplexen Lebens- und
              Gesundheitsverständnis.
              Nach heutigem Wissensstand ist die Information, die einen Menschen erreicht, das was unsere Zellen
              inklusive der DANN in ihrer Arbeit beeinflusst.
              Nicht nur Nahrungsmittel, auch Gedanken, die Einstellung zu Gesundheit von Klient und Berater als auch
              alles andere was uns umgibt, tragen Informationen und Nährwerte in den Menschen hinein. (Eine Currywurst
              mit Pommes hat definitiv andere Informationen gespeichert und somit andere Auswirkungen als gutes
              gedünstetes Gemüse mit Reis.
              <br></br>
              <br></br>
              Viele Wissenschaftler wie Bruce Lipton Prof. Gariaev, Emoto Masuru oder auch Heisenberg zeigen uns, dass
              jede Körperzelle eine optimale Versorgung mit Informationen benötigt, um bestmöglich zu arbeiten und die
              DNA optimale zu reproduzieren. All diese Hinweise finden wir schon in jahrtausendealten Schriften der
              abendländischen Medizin wieder.

            </p>
          </div>
        </div>
      </section>
    </ScrollableAnchor>
);

export default HealthySection;



// WEBPACK FOOTER //
// ./src/courseinfo/healthy.js